// extracted by mini-css-extract-plugin
export default {"root":"WbKPZck8qZ"};